import { render, staticRenderFns } from "./patrolList.vue?vue&type=template&id=cdffd056&scoped=true&"
import script from "./patrolList.vue?vue&type=script&lang=js&"
export * from "./patrolList.vue?vue&type=script&lang=js&"
import style0 from "./patrolList.vue?vue&type=style&index=0&id=cdffd056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdffd056",
  null
  
)

export default component.exports